import Decimal from 'decimal.js';
import { utils } from "../utils";
import { fromDatestampArray, toDatestampArray } from "./time";
import { getLastXMonths, getNextXMonths } from "../utils/date.utils";
import { isSameMonth } from 'date-fns';
const sumTotalAmounts = invoices => invoices.reduce((acc, invoice) => acc.add(invoice.totalAmount), new Decimal(0));
const getMonthsFromThisYear = (invoices, now) => {
  return invoices.filter(_ref => {
    let {
      date
    } = _ref;
    return date[0] === now.getFullYear();
  });
};
export class HistoricRevenueModel {
  static makeEmptyMonth() {
    let {
      date
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
      date: toDatestampArray(date || new Date()),
      totalAmount: new Decimal(0)
    };
  }
  static fromDTO(expectedRevenue, historicPaidInvoices, historicPaidExternallyInvoices, issuedAndPaymentInitiatedInvoices, now) {
    const formattedHistoricPaidInvoices = historicPaidInvoices.map(_ref2 => {
      let {
        rawRevenue,
        day
      } = _ref2;
      return {
        date: day,
        totalAmount: new Decimal(rawRevenue)
      };
    });
    return new HistoricRevenueModel(expectedRevenue, formattedHistoricPaidInvoices, historicPaidExternallyInvoices, issuedAndPaymentInitiatedInvoices, now);
  }
  static fromHistoricInvoiceDTO(_ref3) {
    let {
      date,
      totalAmount
    } = _ref3;
    return {
      date,
      totalAmount: new Decimal(totalAmount)
    };
  }
  constructor(expectedRevenue, historicPaidInvoices, historicPaidExternallyInvoices, issuedAndPaymentInitiatedInvoices, now) {
    this.now = now;
    this.historicPaidInvoices = historicPaidInvoices;
    this.historicPaidExternallyInvoices = historicPaidExternallyInvoices;
    this.expectedRevenue = expectedRevenue;
    if (!this.expectedRevenue.length) {
      this.expectedRevenue = [HistoricRevenueModel.makeEmptyMonth({
        date: now
      })];
    }
    this.expectedRevenue[0].totalAmount = issuedAndPaymentInitiatedInvoices.reduce((acc, invoice) => acc.add(invoice.rawTotalAmount), this.expectedRevenue[0].totalAmount);
  }
  totalThisYear() {
    return utils.formatDollarAmount(this.rawTotalThisYear());
  }
  rawTotalThisYear() {
    return sumTotalAmounts(getMonthsFromThisYear([...this.historicPaidExternallyInvoices, ...this.historicPaidInvoices], this.now));
  }
  hasRevenueThisYear() {
    return this.rawTotalThisYear().gt(0);
  }
  hasExpectedRevenue() {
    return sumTotalAmounts(this.expectedRevenue).gt(0);
  }
  totalPaidExternally() {
    return utils.formatDollarAmount(sumTotalAmounts(this.historicPaidExternallyInvoices));
  }
  totalExpectedThisYear() {
    return utils.formatDollarAmount(this.rawTotalThisYear().add(sumTotalAmounts(getMonthsFromThisYear(this.expectedRevenue, this.now))));
  }
  chartData() {
    const getItem = (date, invoices) => invoices.find(item => isSameMonth(fromDatestampArray(item.date), date)) || HistoricRevenueModel.makeEmptyMonth({
      date
    });
    return [...getLastXMonths(this.now, 12), ...getNextXMonths(this.now, 3)].map(date => ({
      date,
      [RevenueStatus.Paid]: getItem(date, this.historicPaidInvoices),
      [RevenueStatus.Expected]: getItem(date, this.expectedRevenue),
      [RevenueStatus.PaidExternally]: getItem(date, this.historicPaidExternallyInvoices)
    }));
  }
  isEmpty() {
    return this.historicPaidExternallyInvoices.length === 0 && this.historicPaidInvoices.length === 0;
  }
}
export let RevenueStatus = /*#__PURE__*/function (RevenueStatus) {
  RevenueStatus["Paid"] = "paid";
  RevenueStatus["Expected"] = "expected";
  RevenueStatus["PaidExternally"] = "paidExternally";
  return RevenueStatus;
}({});